import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class IPackageTanzimPostDto {
  packageId: number;
  description: string;
  create_date: string;
}

export class IPackageTanzim {
  id: number;
  packageId: number;
  description: string;
  createDate: string;
}

export class IPackageTanzimListResponse extends IPagination {
  @Type(() => IPackageTanzim)
  results: IPackageTanzim[];
}

export class IPackageTanzimResponse {
  @Type(() => IPackageTanzim)
  result: IPackageTanzim;
}

export class IPackageTanzimQueryDto extends IQueryPaginationDto {
  package_id?: number;
  barcode?: string;
  company_id?: string | number;
}
